@if(userForm()){
<form [formGroup]="userForm()">
    <div class="row mb-3">
        <div class="col-md-6 mb-3">
            <div class="form-group">
                <label class="form-label">Correo Electrónico</label>
                @if(mode() === formMode.CREATE || mode() === formMode.EDIT){
                <input type="email" class="form-control" formControlName="mail">
                }@else{
                <div class="form-control-plaintext">
                    <strong>{{userForm().get('mail')?.value}}</strong>
                </div>
                }
            </div>
        </div>
        <div class="col-md-6 mb-3">
            <div class="form-group">
                <label class="form-label">Nombre para Mostrar</label>
                @if(mode() === formMode.CREATE || mode() === formMode.EDIT){
                <input type="text" class="form-control" formControlName="displayName" disabled>
                }@else{
                <div class="form-control-plaintext">
                    <strong>{{userForm().get('displayName')?.value}}</strong>
                </div>
                }
            </div>
        </div>
        <div class="col-md-6 mb-3">
            <div class="form-group">
                <label class="form-label">Roles de Usuario</label>
                @if(mode() === formMode.CREATE || mode() === formMode.EDIT){
                <ng-select
                    [items]="catalogService.roles()"
                    bindLabel="displayName"
                    bindValue="slug"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    placeholder="Seleccione uno o más roles..."
                    [ngModel]="userForm().get('roleSlugs')?.value || userForm().get('roleIds')?.value"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onRolesChange($event)">
                </ng-select>
                <small class="text-muted">El primer rol (o el activo actual si sigue en la lista) será el rol con el que actúa.</small>
                }@else{
                <div class="form-control-plaintext">
                    <strong>{{roleLabels(userForm().get('roleSlugs')?.value || userForm().get('roleIds')?.value)}}</strong>
                    @if (userForm().get('roleSlug')?.value || userForm().get('roleId')?.value) {
                    <div class="text-muted small mt-1">Activo: {{findRole(userForm().get('roleSlug')?.value || userForm().get('roleId')?.value)}}</div>
                    }
                </div>
                }
            </div>
        </div>
        @if (hasUserRole()) {
        <div class="col-md-6 mb-3">
            <div class="form-group">
                <label class="form-label">Socio vinculado</label>
                @if(mode() === formMode.CREATE || mode() === formMode.EDIT){
                <ng-select
                    [items]="parties()"
                    bindLabel="names"
                    bindValue="uuid"
                    [trackByFn]="trackByParty"
                    [searchable]="true"
                    [clearable]="true"
                    [searchFn]="searchParty"
                    placeholder="Seleccione socio (RUT / nombre)..."
                    formControlName="partyUuid">
                    <ng-template ng-label-tmp let-item="item">
                        {{ partyLabel(item) }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        {{ partyLabel(item) }}
                    </ng-template>
                </ng-select>
                <small class="text-muted">El usuario portal ve solo primas, reembolsos y solicitudes de este socio.</small>
                @if (userForm().get('partyUuid')?.invalid && userForm().get('partyUuid')?.touched) {
                <div class="text-danger"><small>Debe seleccionar un socio.</small></div>
                }
                }@else{
                <div class="form-control-plaintext">
                    <strong>{{ partyDisplay() }}</strong>
                </div>
                }
            </div>
        </div>
        }
        <div class="col-md-6 mb-3">
            <div class="form-group">
                <label class="form-label">Fecha de Expiración</label>
                @if(mode() === formMode.CREATE || mode() === formMode.EDIT){
                <input type="date" class="form-control" formControlName="expiredDate" [max]="maxDate()" [min]="minDate()">
                  @if(userForm().get('expiredDate')?.errors?.maxOneYear && userForm().get('expiredDate')?.touched){
                  <div class="text-danger">
                    <small>La fecha de expiración no puede ser superior a un año.</small>
                  </div>
                  }
                  <div class="text-muted">
                    <small><i class="fas fa-info-circle"></i> Rango: [{{minDate()}}] - [{{maxDate()}}]</small>
                  </div>
                  @if(userForm().get('expiredDate')?.errors?.minYear && userForm().get('expiredDate')?.touched){
                  <div class="text-danger">
                    <small>La fecha de expiración no puede ser anterior al año en curso.</small>
                  </div>
                  }
                }@else{
                <div class="form-control-plaintext">
                    <strong>{{userForm().get('expiredDate')?.value}}</strong>
                </div>
                }
            </div>
        </div>
    </div>
    @if(mode() === formMode.VIEW){
    <div class="row">
        <div class="col-12 d-flex justify-content-end gap-2">
            @if (perm.canCurrent('canUpdate')) {
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="editMode()">
                <i class="fas fa-edit"></i> Editar
            </button>
            }
            @if (perm.canCurrent('canUpdate')) {
            @if(userForm().get('isActive')?.value){
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="updateUser(0)">
                <i class="fas fa-times"></i> Desactivar
            </button>
            }@else{
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="updateUser(1)">
                <i class="fas fa-check"></i> Activar
            </button>
            }
            }
        </div>
    </div>
    }
</form>
<ng-content><!-- contenido adicional por el padre --> </ng-content>
}
